import axios from 'axios';
import config from '../config';
import securityService from './SecurityService';

export class AdminUserService {

  public getAdminUsers(): Promise<any> {
    let reqConfig = securityService.getAuthorizeHeaders();
    reqConfig = {
      ...reqConfig
    }
    return axios.get(`/api/admin-user`, reqConfig);
  }

  public getInvite(email: string): Promise<any> {
    let reqConfig = securityService.getAuthorizeHeaders();
    reqConfig = {
      ...reqConfig
    }
    return axios.get(`/api/admin-user/invite/${email}`, reqConfig);
  }

  public getAdminUser(id: number): Promise<any> {
    let reqConfig = securityService.getAuthorizeHeaders();
    reqConfig = {
      ...reqConfig,
      params: {
        embedded: true
      }
    }

    return axios.get(`/api/admin-user/${id}`, reqConfig);
  }

  public updateAdminUser(adminUser: any) {
    const { id } = adminUser;
    let reqConfig = securityService.getAuthorizeHeaders();
    return axios.put(`/api/admin-user/${id}`, adminUser, reqConfig);
  }

  public inviteUser(inviteEmail: string, inviteRole: string) {
    let reqConfig = securityService.getAuthorizeHeaders();
    const inviteUser = {
      inviteEmail,
      inviteRole
    }
    return axios.post(`/api/admin-user/invite`, inviteUser, reqConfig);
  }

  public reInviteUser(inviteEmail: string) {
    let reqConfig = securityService.getAuthorizeHeaders();
    return axios.put(`/api/admin-user/re-invite/${inviteEmail}`, inviteEmail, reqConfig);
  }

  public confirmInvite(inviteToken: string): Promise<any> {
    return axios.put(`/api/admin-user/invite/${inviteToken}`);
  }

  public deleteAdminUser(txt: string): Promise<any> {
    let reqConfig = securityService.getAuthorizeHeaders();
    reqConfig = {
      ...reqConfig
    }
    return axios.delete(`/api/admin-user/${txt}`, reqConfig);
  }
}

const adminUserService = new AdminUserService();
export default adminUserService;
